<template>
  <div>
    <el-row type="flex" :gutter="32" align="bottom" :style="{ flexWrap: 'wrap' }">

      <el-col :span="4" :style="{ flex: '1' }">
        <h2 :style="{ margin: '0' }">รายการทองโอน</h2>
      </el-col>


      <el-col v-if="!this.readonly" :span="4">
        <el-button type="primary" plain icon="el-icon-plus" @click="// @ts-ignore
addItem()">
          เพิ่มรายการ
        </el-button>
      </el-col>
    </el-row>

    <el-card :style="{ marginTop: '1rem' }">

      <el-table :data="this.data" :headerCellClassName="elementUiStyles.tableCell"
        :cellClassName="elementUiStyles.tableCell" :rowClassName="this.tableRowClassName" showSummary
        :summary-method="(params) => {return this.getSummaries(params) }">

        <el-table-column minWidth="140">
          <template #default="scope">
            <div>
              <el-button type="danger" circle icon="el-icon-close" size="mini" @click="// @ts-ignore
removeItem(scope.$index)" />
              <span :style="{ marginLeft: '0.5rem', fontWeight: 'bold', verticalAlign: 'middle' }">
                รายการที่ {{ scope.$index + 1 }}
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="รหัสสินค้า" minWidth="150">
          <template #default="scope">
            <el-select v-model="scope.row.product_id" :style="{ width: '100%' }" @change="// @ts-ignore
select_change(scope.$index)">
              <el-option v-for="(item,index) in products" :key="index" :label="item.product_name"
                :value="item.product_id" style="border:0;padding:0;margin-left:1rem;" />
            </el-select>
          </template>
        </el-table-column>

        <el-table-column label="% ทอง" align="right" minWidth="100">
          <template #default="scope">
            <span v-if="scope.row.product">
              {{ scope.row.product.purity_percentage }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="จำนวน" prop="amount" align="right" minWidth="100">
          <template #default="scope">

            <span v-if="readonly"> {{ scope.row.amount }}</span>
            <NumberInput :value="scope.row.amount" :min="0" format="0" @input="vl => {
                // @ts-ignore
                handle_amount(scope.$index, vl)
              }" />
          </template>
        </el-table-column>

        <el-table-column label="น้ำหนักรวม (บาท)" prop="weight" align="right" minWidth="120">
          <template #default="scope">
            <span v-if="readonly"> {{ scope.row.weight }}</span>
            <NumberInput :value="scope.row.weight" :min="0" @input="(vl) =>{
            // @ts-ignore
              handle_weight(scope.$index, vl)
            }" />

          </template>
        </el-table-column>

        <el-table-column label="น้ำหนักรวม (g)" prop="realWeight" align="right" minWidth="120">
          <template #default="scope">
            <span v-if="readonly"> {{ scope.row.realWeight }}</span>
            <NumberInput :value="scope.row.realWeight" :min="0" @input="(vl) => {
            // @ts-ignore
            handle_realweight(scope.$index, vl)
          }" />
          </template>
        </el-table-column>

      </el-table>
    </el-card>

  </div>
</template>



<script>
import numeral from 'numeral'
import { NumberInput } from '@/components/form/number-input'
// @ts-ignore
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'
// @ts-ignore
//import { round, floor } from 'mathjs'

//import { BuyProductService } from '@/services'
//import { SellProductService } from '@/services'

//const ProductProvider = () => import('./ProductProvider')

export default {
  components: {
      NumberInput,
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },

    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      elementUiStyles,
      items:[],
      products: [],
      error: null,
    }
  },
  async created() {
      console.log("Start Fetch")
      this.fetchProduct()
      console.log("End Fetch")
  },
  methods: {
    select_change(inx) {
      const product_id = this.data[inx].product_id

      const find_product = this.products.find( item =>
                    item.product_id === product_id
                  )

      this.data[inx].product = find_product
    },
    handle_amount(inx,vl) {
      this.data[inx].amount = vl
      if (this.data[inx].product) {
        const product = this.data[inx].product
        this.data[inx].weight = this.roundTo(vl * product.baht_weight,2)
        this.data[inx].realWeight = this.roundTo(vl * product.real_weight,2)
      }
    },
    handle_weight(inx, vl) {
      const baseValue = Math.floor(vl / 0.25) * 0.25
      const modValue = vl % 0.25
      const value = (modValue >= 0.125) ? baseValue + 0.25 : baseValue
      this.data[inx].weight = value

      if (this.data[inx].product) {
          const product = this.data[inx].product
          this.data[inx].realWeight = this.roundTo((product.real_weight / product.baht_weight) * value, 2)
      }
    },
    handle_realweight(inx, vl) {
      this.data[inx].realWeight = this.roundTo(vl, 2)
    },
    roundTo(n, digits) {
      let negative = false
      if (digits === undefined) {
        digits = 0;
      }
      if (n < 0) {
        negative = true;
        n = n * -1;
      }

      let multiplicator = Math.pow(10, digits)
      n = parseFloat((n * multiplicator).toFixed(11))
      n = (Math.round(n) / multiplicator).toFixed(digits)

      if (negative) {
        n = (n * -1).toFixed(digits)
      }
      return parseFloat(n)
    },
    async fetchProduct() {
       try {
        await this.$store.dispatch('getproduct')
        this.products = this.$store.getters['products']

        console.log(this.products)
      } catch (err) {
        console.log(err)
        this.error = err
      }
    },
    getSummaries(param) {

      console.log('sum')
      console.log(param)


           const { columns, data } = param
            const sums = []

            columns.forEach((column, index) => {
              if (index === (this.readonly ? 1 : 2)) {

                //let dateSpan = document.createElement('span')
                //dateSpan.innerHTML = 'รวม'

                sums[index] = (<span style='font-weight:bold;font-size:1.125rem;'>รวม</span>)

                //sums[index] = '<span>รวม</span>'


/*                 sums[index] = `
                  <span style={{ fontWeight: 'bold', fontSize: '1.125rem' }}>
                    รวม
                  </span>
                ` */
                return
              }

              const values = data.map(item => Number(item[column.property]))

              if (values.some(value => isNaN(value))) return

              const reducedValue = values.reduce((prev, curr) => prev + curr, 0)

              if (index === (this.readonly ? 2 : 3)) {
                sums[index] = (<span style='font-weight:bold;'>{numeral(reducedValue).format('0,0')}</span>)
                return
              }

              sums[index] = (<span style='font-weight:bold;'>{numeral(reducedValue).format('0,0.00')}</span>)
            })

            return sums
    },




/*     async fetch() {
      try {
        const {
          data: { result }
        } = await SellProductService.getMinimalAll({ all: true })

        console.log(result)

        this.items = result.map(item => ({
          id: item.id,
          name: item.name
        }))
      } catch (e) {
        this.items = []
      } finally {
        //this.isLoaded = true
      }
    },

    async fetchDetail(id) {
      try {
        const {
          data: { result }
        } = await SellProductService.get(id)

        return {
          id: result.id,
          name: result.name,
          percent: +result.purity_percentage / 100,
          weight: +result.baht_weight,
          realWeight: +result.real_weight
        }
      } catch (e) {
        return null
      }
    },

    async fetchBuy() {
      try {
        const {
          data: { result }
        } = await BuyProductService.getMinimalAll({ all: true })

        this.items = result.map(item => ({
          id: item.id,
          name: item.name
        }))
      } catch (e) {
        this.items = []
      } finally {
        //this.isLoaded = true
      }
    },


    async fetchBuyDetail(id) {
      try {
        const {
          data: { result }
        } = await BuyProductService.get(id)

        return {
          id: result.id,
          name: result.name,
          percent: +result.purity_percentage / 100,
          weight: +result.baht_weight,
          realWeight: +result.real_weight
        }
      } catch (e) {
        return null
      }
    }, */




    addItem() {
      this.$emit('change', [
        ...this.data,
        {
          product_id: '',
          product: null,
          amount: 0,
          weight: 0,
          realWeight: 0
        }
      ])
    },

    updateItem(index, key, value) {
      const data = [...this.data]
      data[index] = { ...data[index], [key]: value }
      return this.$emit('change', data)
    },

    removeItem(index) {
      console.log('remove')
      this.$emit(
        'change',
        // @ts-ignore
        this.data.filter((item, itemIndex) => itemIndex !== index)
      )
    },

    async updateProduct(index, row, product) {
      await this.updateItem(index, 'product', product)

      if (product) {
        await this.updateItem(
          index,
          'weight',
          this.roundTo(product.weight * row.amount, 2)
        )

        await this.updateItem(
          index,
          'realWeight',
          this.roundTo(product.realWeight * row.amount, 2)
        )
      }
    },

/*     async updateAmount(index, row, value) {
      console.log([index, row, value])


       await this.updateItem(index, 'amount', value)

      if (row.product) {
        await this.updateItem(
          index,
          'weight',
          round(value * row.product.weight, 2)
        )

        await this.updateItem(
          index,
          'realWeight',
          round(value * row.product.realWeight, 2)
        )
      }
    }, */

/*     async updateWeight(index, row, value) {
      const baseValue = Math.floor(value / 0.25) * 0.25,
        modValue = value % 0.25

      if (modValue >= 0.125) value = baseValue + 0.25
      else value = baseValue

      await this.updateItem(index, 'weight', value)

      if (row.product) {
        await this.updateItem(
          index,
          'realWeight',
          this.roundTo((row.product.realWeight / row.product.weight) * value, 2)
        )
      }
    }, */

    tableRowClassName({ row }) {
      if (row.available === false) return this.$style.dangerRow
      return ''
    },





  },
/*
  render() {
    const Header = () => (
      <el-row
        type="flex"
        gutter={32}
        align="bottom"
        style={{ flexWrap: 'wrap' }}
      >
        <el-col span={null} style={{ flex: '1' }}>
          <h2 style={{ margin: '0' }}>รายการทองโอน</h2>
        </el-col>
        {!this.readonly && (
          <el-col span={null}>
            <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              onClick={this.addItem}
            >
              เพิ่มรายการ
            </el-button>
          </el-col>
        )}
      </el-row>
    )

    const DataTable = () => {
      const ItemNumber = ({ props }) => (
        <div>
          <el-button
            type="danger"
            circle
            icon="el-icon-close"
            size="mini"
            onClick={() => {
              this.removeItem(props.index)
            }}
          />
          <span
            style={{
              marginLeft: '0.5rem',
              fontWeight: 'bold',
              verticalAlign: 'middle'
            }}
          >
            รายการที่ {props.index + 1}
          </span>
        </div>
      )

      const getSummaries = params => {
        const { columns, data } = params
        const sums = []

        columns.forEach((column, index) => {
          if (index === (this.readonly ? 1 : 2)) {
            sums[index] = (
              <span style={{ fontWeight: 'bold', fontSize: '1.125rem' }}>
                รวม
              </span>
            )
            return
          }

          const values = data.map(item => Number(item[column.property]))

          if (values.some(value => isNaN(value))) return

          const reducedValue = values.reduce((prev, curr) => prev + curr, 0)

          if (index === (this.readonly ? 2 : 3)) {
            sums[index] = (
              <span style={{ fontWeight: 'bold' }}>
                {numeral(reducedValue).format('0,0')}
              </span>
            )
            return
          }

          sums[index] = (
            <span style={{ fontWeight: 'bold' }}>
              {numeral(reducedValue).format('0,0.00')}
            </span>
          )
        })

        return sums
      }

      const Root = this.readonly ? 'div' : 'el-card'

      return (
        <Root style={{ marginTop: '1rem' }}>
          <ProductProvider
            scopedSlots={{
              default: ({ items, fetchDetail }) => (
                <el-table
                  data={this.data}
                  headerCellClassName={elementUiStyles.tableCell}
                  cellClassName={elementUiStyles.tableCell}
                  rowClassName={this.tableRowClassName}
                  showSummary
                  summaryMethod={getSummaries}
                >
                  {this.readonly ? (
                    <el-table-column
                      label="รายการสินค้า"
                      minWidth="200"
                      scopedSlots={{
                        default: ({ row }) => row.product.name
                      }}
                    />
                  ) : (
                    [
                      <el-table-column
                        minWidth="140"
                        scopedSlots={{
                          default: ({ $index }) => <ItemNumber index={$index} />
                        }}
                      />,
                      <el-table-column
                        label="รหัสสินค้า"
                        minWidth="150"
                        scopedSlots={{
                          default: ({ row, $index }) => (
                            <el-select
                              value={row.product}
                              valueKey="id"
                              filterable
                              style={{ width: '100%' }}
                              onChange={async value => {
                                this.updateProduct(
                                  $index,
                                  row,
                                  await fetchDetail(value.id)
                                )
                              }}
                              nativeOnTouchend={e => {
                                e.target.readOnly = false
                              }}
                            >
                              {items.map((item, index) => (
                                <el-option
                                  key={index}
                                  label={item.name}
                                  value={item}
                                />
                              ))}
                            </el-select>
                          )
                        }}
                      />
                    ]
                  )}

                  <el-table-column
                    label="% ทอง"
                    align="right"
                    minWidth="100"
                    scopedSlots={{
                      default: ({ row }) =>
                        row.product &&
                        numeral(row.product.percent).format('0.00%')
                    }}
                  />
                  <el-table-column
                    label="จำนวน"
                    prop="amount"
                    align="right"
                    minWidth="100"
                    scopedSlots={{
                      default: ({ row, $index }) =>
                        this.readonly ? (
                          row.amount
                        ) : (
                          <NumberInput
                            value={row.amount}
                            min={0}
                            format="0"
                            onInput={value => {
                              this.updateAmount($index, row, value)
                            }}
                          />
                        )
                    }}
                  />
                  <el-table-column
                    label="น้ำหนักรวม (บาท)"
                    prop="weight"
                    align="right"
                    minWidth="120"
                    scopedSlots={{
                      default: ({ row, $index }) =>
                        this.readonly ? (
                          numeral(row.weight).format('0,0.00')
                        ) : (
                          <NumberInput
                            value={row.weight}
                            min={0}
                            onInput={value => {
                              this.updateWeight($index, row, value)
                            }}
                          />
                        )
                    }}
                  />
                  <el-table-column
                    label="น้ำหนักรวม (g)"
                    prop="realWeight"
                    align="right"
                    minWidth="120"
                    scopedSlots={{
                      default: ({ row, $index }) =>
                        this.readonly ? (
                          numeral(row.realWeight).format('0,0.00')
                        ) : (
                          <NumberInput
                            value={row.realWeight}
                            min={0}
                            onInput={value => {
                              this.updateItem($index, 'realWeight', value)
                            }}
                          />
                        )
                    }}
                  />
                </el-table>
              )
            }}
          />
        </Root>
      )
    }

    return (
      <div>
        <Header />
        <DataTable />
      </div>
    )
  } */
}
</script>

<style lang="scss" module>
.dangerRow {
  > td {
    background-color: $--color-danger-lighter !important;
  }
}
</style>
